export default {
    init() {
        // JavaScript to be fired on the home page

        // Masthead carousel
        $('#newsletter-toggle').click( function() {
			$('#newsletter-descriptions').slideToggle('fast', function() {
				$('#newsletter-toggle').text( $('#newsletter-descriptions').is(':visible') ? "Hide Newsletter Descriptions" : "View Newsletter Descriptions");
			});
			return false;
		});
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// /Users/mishatrombley/Documents/Sites/aurora-institute/app/public/wp-content/themes/aurora-institute/resources/assets/scripts/routes/register.js